<template>
  <text-area v-on="$listeners" v-bind="$attrs" label="Anotações" no-resize :max-length="2000" :rows="4" v-model="value">
  </text-area>
</template>

<script>
import TextArea from '../../../../TextArea.vue'

import { createNamespacedHelpers } from 'vuex'

const { mapGetters: attendanceGettersMap, mapActions: attendanceActionsMap } = createNamespacedHelpers('attendance')

export default {
  components: { TextArea },
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    value: {
      get() {
        return this.getPhaseDataByKey('notes')
      },
      set(value) {
        this.setPhaseData({
          key: 'notes',
          data: value,
        })
      },
    },
  },
  methods: {
    ...attendanceActionsMap(['setPhaseData']),
  },
}
</script>

<style></style>
